import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

//components
import ListaFuncionalidades from '../childrens/funcionalidades/.mixins';

//css
import SectionCss from './styles';
const useStyles = SectionCss();

export default function Section(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>

                <Box component="span" m={1}>
                    <Paper className={classes.root}>
                        <div className={classes.boxForm}>
                            <Typography variant="h5" component="h3" className={classes.title}>
                                {props.state.tipo} {props.props.route.title}
                            </Typography>
                            <form className={classes.container} noValidate autoComplete="off">
                                <TextField variant={"filled"}
                                    id="standard-name"
                                    label="Descrição"
                                    className={classes.textField}
                                    InputProps={{
                                        className: classes.multilineColor
                                    }}
                                    margin="normal"
                                    onChange={(e)=>{props.setState({descricao:e.target.value})}}
                                    value={props.state.descricao}
                                />
                                <br/>
                                {props.props.params.id &&
                                    <ListaFuncionalidades {...props}/>
                                }
                                {props.state.tipo !== 'Editar' &&
                                    <div className={classes.buttonAction} align="right">
                                        <Button className={classes.buttonCancelar} onClick={()=>{props.props.router.goBack();}}>
                                            Cancelar
                                        </Button>
                                        <Button variant="contained" color="primary" onClick={()=>{props.validacao(props)}}>
                                            {(props.state.tipo === 'Editar')?'Salvar':'Salvar'}
                                        </Button>
                                    </div>
                                }
                            </form>
                        </div>
                    </Paper>
                </Box>

            </div>
        </div>
    );
}